namespace RioERP.Web.Enums {
    export enum AccessStatus {
        All = 1,
        Selected = 2
    }
    Serenity.Decorators.registerEnumType(AccessStatus, 'RioERP.Web.Enums.AccessStatus');
}
